module.exports = __webpack_public_path__ + "static/media/kcwa_seal.24baaba9.png";